import React from 'react';
import ModalHeader from '../molecules/ModalHeader';
import ModalFooter from '../molecules/ModalFooter';
import ContactForm from '../molecules/ContactForm';

/**
 * Step3ContactData - Paso 3: Datos de contacto
 *
 * Props:
 * - email: Valor actual del email
 * - confirmEmail: Valor actual de confirmación de email
 * - phone: Valor actual del teléfono
 * - onChange: Función callback (fieldName, value) => void
 * - errors: Objeto con errores { email, confirmEmail, phone }
 * - onBack: Función callback para volver
 * - onContinue: Función callback para continuar
 * - className: Clases CSS adicionales (opcional)
 */
function Step3ContactData({
  email = '',
  confirmEmail = '',
  phone = '',
  onChange,
  errors = {},
  onBack,
  onContinue,
  className = ''
}) {
  return (
    <div className={`d-flex flex-column gap-4 mx-auto ${className}`}>
      <ModalHeader
        title="Completa tu Información"
        subtitle="Datos de Contacto"
        currentStep={2}
      />

      <ContactForm
        email={email}
        confirmEmail={confirmEmail}
        phone={phone}
        onChange={onChange}
        errors={errors}
      />

      <ModalFooter
        onBack={onBack}
        onContinue={onContinue}
        continueText="Continuar"
        backText="Atrás"
      />
    </div>
  );
}

export default Step3ContactData;
